// FIRST: profiler probes wrapping WebSocket/timers/the React DevTools hook in
// `pnpm build:profile` builds; must load before react-dom and any socket.
import "@/lib/perfRuntimeInstall";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { deletionCacheReady } from "@/services/nostr";
import App from "./App.tsx";
import "./index.css";
import "@fontsource-variable/inter";

// Unregister any service worker left behind by the previous codebase and clear
// its caches. The tombstone SW (sw.js) handles the actual cleanup then removes
// itself, so subsequent loads are fully uncontrolled. Capacitor packages local
// assets and does not use this web-deployment cleanup worker.
if (!Capacitor.isNativePlatform() && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {
    /* ignore — browser may block in certain envs */
  });
}

async function bootstrap(): Promise<void> {
  // Restore durable kind-5 state before any component can load stale cached
  // originals into the EventStore.
  await deletionCacheReady;

  createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>,
  );
}

void bootstrap();
